import { render, staticRenderFns } from "./resource-batch-review-dialog.vue?vue&type=template&id=3254279e&scoped=true"
import script from "./resource-batch-review-dialog.vue?vue&type=script&lang=js"
export * from "./resource-batch-review-dialog.vue?vue&type=script&lang=js"
import style0 from "./resource-batch-review-dialog.vue?vue&type=style&index=0&id=3254279e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254279e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3254279e')) {
      api.createRecord('3254279e', component.options)
    } else {
      api.reload('3254279e', component.options)
    }
    module.hot.accept("./resource-batch-review-dialog.vue?vue&type=template&id=3254279e&scoped=true", function () {
      api.rerender('3254279e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/resource-batch-review-dialog.vue"
export default component.exports